import { ChatUI } from '@voxityai/chat-ui';
import { PLATFORM_TENANT_KEY } from '@actions/services/agents/platformTenancy';
import { auth } from '@actions/services/firestore/browser/firebase';
import useUserViewContext from '@/components/Layout/UserViewContext/hooks/useUserViewContext';
import WebappChatUIErrorBoundary from '@/components/Layout/WebappChatUI/WebappChatUIErrorBoundary';
import useChatEffects from '@/components/Layout/WebappChatUI/chatEffects';
import type { AdminChatUIComponent } from './types';

const PLATFORM_CHAT_NAMESPACE = 'platform';

const ChatUIComponent = ChatUI as unknown as AdminChatUIComponent;

const AdminChatUI = () => {
    const { userViewContext } = useUserViewContext();
    const handleChatEvent = useChatEffects({});
    const server = import.meta.env.VITE_ACTIONS_BASE_URL || 'http://localhost:8080';
    const widgetUrl = import.meta.env.VITE_CHAT_UI_WIDGET_URL;

    return (
        <WebappChatUIErrorBoundary>
            <ChatUIComponent
                auth={auth}
                server={server}
                namespace={PLATFORM_CHAT_NAMESPACE}
                organizationId={PLATFORM_TENANT_KEY}
                userViewContext={userViewContext}
                widgetUrl={widgetUrl}
                onEvent={handleChatEvent}
            />
        </WebappChatUIErrorBoundary>
    );
};

export default AdminChatUI;
